<template>
  <div>
    <a-modal
      title=""
      okText="收起"
      :closable=true
      :visible="expiredOrderDialog.visible"
      @ok="closeMask"
      @cancel="closeMask"
      :mask="expiredOrderDialog.showMask"
      :footer="null"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-row>
          <a-col :md="24" :sm="24">
            <span>数据导出量大时，请到<a href="/icp/task">任务中心</a>查看结果</span>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-progress :percent="percent" :showInfo="true"/>
          </a-col>
          <a-col :md="24" :sm="24">
            <a  :href="fileUrl" v-show="showDownLoad">文件下载</a>
          </a-col>
        </a-row>

      </a-form>
    </a-modal>

    <a-modal
      title="导出提示"
      :visible="exportAlert.visible"
      @ok="closeExportAlertMask"
      :mask="exportAlert.showMask"
    >
      <span>导出异常，请到<a href="/icp/task">任务中心</a>查看</span>
    </a-modal>
  </div>

</template>
<script>

import {DownLoadApi} from '../../js/DownLoadApi'
import request from '../../utils/request'

export default {
  name: 'exportAlert',
  data () {
    return {
      form: this.$form.createForm(this, {name: 'export_alert'}),
      expiredOrderDialog: {
        visible: false,
        showMask: true
      },
      fileUrl: '',
      showDownLoad: false,
      exportAlert: {
        visible: false,
        showMask: true
      },
      percent: 0
    }
  },
  destroyed () {
  },
  created () {
    this.fileUrl = ''
    this.percent = 0
    this.showDownLoad = false
  },
  methods: {
    exportFile (requestJson,typeVal) {
      this.fileUrl = ''
      this.percent = 0
      this.showDownLoad = false
      request({
        url: DownLoadApi.DownLoadUrl.exportUrl,
        method: 'post',
        params: {
          taskParameterJson: requestJson,
          taskType: typeVal
        }
      }).then(response => {
        var data = response.data
        if (!data.success) {
          this.expiredOrderDialog.visible = false
          this.exportAlert.visible = true
          return
        }
        this.expiredOrderDialog.visible = true
        for (let i = 0; i < 30; i++) {
          this.sleep(300)
          this.assemblyExportResult(response)
        }
      })
      this.expiredOrderDialog.visible = true
    },
    closeMask () {
      this.expiredOrderDialog.showMask = false
      this.expiredOrderDialog.visible = false
    },
    closeExportAlertMask () {
      this.exportAlert.showMask = false
      this.exportAlert.visible = false
    },
    processProcessResult (response) {
      var data = response.data
      var realPercent = parseInt(data.model.percent)
      if (data.success) {
        if (realPercent >= 100) {
          this.percent = 100
          if (data.model.fileUrl != '') {
            this.showDownLoad = true
            this.fileUrl = data.model.fileUrl
          }
          return
        }
        if (this.percent < realPercent) {
          this.percent = realPercent
        }
      }
    },
    assemblyExportResult (response) {
      var data = response.data
      request({
        url: DownLoadApi.DownLoadUrl.queryExportFileUrl,
        method: 'post',
        params: {
          taskId: data.model
        }
      }).then(response => {
        this.processProcessResult(response)
      })
    },
    sleep (sleepTime) {
      for (var start = new Date(); new Date() - start <= sleepTime;) {
      }
    }
  }
}
</script>

<style>
  span{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/ExportAlert.vue